import { useQuery } from "@tanstack/react-query";
import { restaurantExtrasApi } from "@/api/restaurantExtras";

export function useRestaurantExtras() {
  return useQuery({
    queryKey: ["restaurantExtras"],
    queryFn: restaurantExtrasApi.getExtras,
  });
}
